module.exports = __webpack_public_path__ + "media/common/images/cta/beth-c6734aee16835a6281a0fa8f99e65e83.jpeg";